import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { intakeQuestionnaireActions } from '../../../../../../../store';

import type { AppDispatch } from '../../../../../../../store';
import type { EducationPayload } from '../../../../../../common';

export default function useIntakeEducationInfo() {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const { intakeQuestionnaireId } = useParams<'intakeQuestionnaireId'>();

  const update = useCallback(
    async (data: EducationPayload) => {
      if (!intakeQuestionnaireId) return false;
      const result = await dispatch(
        intakeQuestionnaireActions.updateIntakeEducationInfo({
          intakeQuestionnaireId,
          data,
          getAccessTokenSilently,
        }),
      );
      return intakeQuestionnaireActions.updateIntakeEducationInfo.fulfilled.match(result);
    },
    [dispatch, getAccessTokenSilently, intakeQuestionnaireId],
  );

  return { update };
}
